import React, { Fragment, useState, useEffect } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SchoolIcon from '@mui/icons-material/School';
import Box from '@mui/material/Box';

import { setDataAction } from 'redux/actions/getFormActions';
import { schoolyearArray, educationArray } from 'utils/constants';
import {
  Dropdown,
  Button,
  Input,
  colors,
  Radio,
  DatePickerInput,
  IconGraphy,
  Typography,
} from '@leapeasy/ui-kit';
import { CustomInputWrapper } from 'components/CustomWrapper';
import { validationMessages } from 'utils/validationMessages';

const Form6 = (props) => {
  const { actions, token, formData, handleNext, handleBack } = props;

  const [data, setFormData] = useState({
    schoolyear: null,
    education: null,
    employment: null,
    eviction: false,
    employmentStartDate: null,
    cash: null,
    annualIncome: null,
    gpa: null,
  });

  const [employmentArray, setEmploymentArray] = useState([]);
  let disable = true;

  useEffect(() => {
    setFormData({
      schoolyear: formData.data.schoolyear,
      education: formData.data.education,
      employment: formData.data.employment,
      eviction: formData.data.eviction,
      employmentStartDate: formData.data.employmentStartDate || null,
      cash: formData.data.cash,
      annualIncome: formData.data.annualIncome,
      gpa: formData.data.gpa,
    });
    if (!formData.data.isCitizen && !formData.isStudent) {
      setEmploymentArray(['Unemployed', 'Employed', 'Self-Employed', 'Retired']);
    } else {
      setEmploymentArray(['Unemployed', 'Employed', 'Self-Employed', 'Retired']);
    }
  }, [formData]);

  const handleChange = (e, label, type = null) => {
    let value;
    if (type === 'date') {
      value = e.target.value;
      if (label === 'employmentStartDate') {
        if (
          new Date(value).getFullYear() >= 1980 &&
          new Date().getFullYear() >= new Date(value).getFullYear()
        ) {
          setFormData({ ...data, [label]: value });
        }
      } else {
        setFormData({ ...data, [label]: value });
      }
    } else if (type !== 'date') {
      value = e.target.value;
      if (label === 'schoolyear') {
        value === 'Freshman'
          ? setFormData({ ...data, [label]: value, gpa: '3.0' })
          : setFormData({ ...data, [label]: value, gpa: null });
      } else {
        setFormData({ ...data, [label]: value });
      }
    }
  };

  if (formData.data.isStudent) {
    data.schoolyear && data.education && data.gpa && data.gpa !== ' '
      ? (disable = false)
      : (disable = true);
  } else {
    if (data.employment === 'Unemployed' || data.employment === 'Retired') {
      data.employment && data.education && data.cash ? (disable = false) : (disable = true);
    } else {
      data.employment &&
      data.education &&
      data.cash &&
      data.employmentStartDate &&
      data.annualIncome
        ? (disable = false)
        : (disable = true);
    }
  }

  const handleNextButton = () => {
    actions.setDataAction({
      ...formData.data,
      schoolyear: data.schoolyear,
      education: data.education,
      employment: data.employment,
      eviction: data.eviction,
      gpa: data.gpa,
      cash: data.cash,
      employmentStartDate: data.employmentStartDate,
      annualIncome: data.annualIncome,
      declined:
        data.annualIncome &&
        formData.data.totalMthRent &&
        data.annualIncome < formData.data.totalMthRent * 27
          ? true
          : false,
    });
    handleNext();
  };

  return (
    <Fragment>
      <Box display="flex" flexDirection="column" gap="4px">
        {formData.data.isStudent && (
          <Dropdown
            label="Year of School during Lease"
            value={data.schoolyear}
            size="medium"
            onChange={(e) => handleChange(e, 'schoolyear')}
            options={schoolyearArray.map((item) => ({
              text: item,
              value: item,
            }))}
            multiselect={false}
            placeholder="Select item"
            showSearch={false}
            style={{
              minWidth: '100%',
            }}
            icon={<IconGraphy icon="EducationWork.ImportContacts" />}
            iconVisible
          />
        )}

        <Dropdown
          label="Highest Education Achieved"
          value={data.education}
          size="medium"
          onChange={(e) => handleChange(e, 'education')}
          options={educationArray.map((item) => ({
            text: item,
            value: item,
          }))}
          multiselect={false}
          placeholder="Select item"
          showSearch={true}
          style={{
            minWidth: '100%',
          }}
          icon={<IconGraphy icon="EducationWork.School" />}
          iconVisible
        />

        <Box mb={2}>
          <Typography variant="body1" style={{ color: colors.purple[900], fontWeight: '400' }}>
            Have you been evicted in the last 3 years?
          </Typography>

          <Box display="flex" alignItems="flex-start" sx={{ gap: '24px', marginTop: 2 }}>
            <Radio
              label="Yes"
              value={data.eviction === true}
              onChange={(_) => handleChange({ target: { value: true } }, 'eviction')}
            />
            <Radio
              label="No"
              value={data.eviction === false}
              onChange={(_) => handleChange({ target: { value: false } }, 'eviction')}
            />
          </Box>
        </Box>

        {formData.data.isStudent && data.schoolyear !== 'Freshman' && (
          <CustomInputWrapper>
          <Input
            value={data.gpa}
            onChange={(e) => handleChange(e, 'gpa')}
            label="Cumulative GPA"
            type="number"
            icon={<SchoolIcon sx={{ fontSize: 40 }} color="primary" />}
            helperMessage={validationMessages.gpa}
            minWidth="100%"
            fullWidth
            minValue={0}
            maxValue={4.01}
            showCopy={false}
          /></CustomInputWrapper>
        )}
        {!formData.data.isStudent && (
          <>
            <Dropdown
              label="Employment Status"
              value={data.employment}
              size="medium"
              onChange={(e) => handleChange(e, 'employment')}
              options={employmentArray.map((item) => ({
                text: item,
                value: item,
              }))}
              multiselect={false}
              placeholder="Select item"
              showSearch={true}
              style={{
                minWidth: '100%',
              }}
              icon={<IconGraphy icon="EducationWork.WorkOutline" />}
              iconVisible
            />

            {data.employment && (
              <>
              <CustomInputWrapper>
                <Input
                  value={data.annualIncome}
                  onChange={(e) => handleChange(e, 'annualIncome')}
                  label="Gross Annual Income"
                  helperMessage={validationMessages.yearlyIncome}
                  type="number"
                  icon={<IconGraphy icon="Finance.Payments" />}
                  minWidth="100%"
                  size="medium"
                  showCopy={false}
                  fullWidth
                  maxValue={10000000000}
                /></CustomInputWrapper>

                {(data.employment === 'Employed' ||
                  data.employment === 'Self-Employed' ||
                  data.employment === 'Retired') && (
                    <Box
                      className="rg-datepicker"
                      sx={{ position: 'relative', zIndex: 10, overflow: 'visible', width: '100%' }}
                    >
                      <DatePickerInput
                        label={
                          data.employment === 'Retired'
                            ? 'Retirement Month and Year'
                            : 'Employment Start Month and Year'
                        }
                        value={data.employmentStartDate || ''}
                        onChange={(e) => handleChange(e, 'employmentStartDate', 'date')}
                        minWidth="100%"
                        size="medium"
                        maxDate={new Date().toISOString().slice(0, 10)}
                        minDate="1980/01/01"
                        fullWidth
                        showActionButtons
                      />
                    </Box>
                  )}
<CustomInputWrapper>
                <Input
                  value={data.cash}
                  onChange={(e) => handleChange(e, 'cash')}
                  label="Available Cash"
                  helperText={
                    data.employment === 'Retired'
                      ? 'Available cash in bank account(s) including retirement.'
                      : 'Available cash in bank account(s) excluding retirement'
                  }
                  type="number"
                  icon={<IconGraphy icon="Finance.Payments" />}
                  minWidth="100%"
                  size="medium"
                  showCopy={false}
                  maxValue={10000000000}
                  fullWidth
                /></CustomInputWrapper>
              </>
            )}
          </>
        )}
      </Box>

      <Box
        sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', mt: 4, gap: '16px' }}
      >
        <Button size="medium" variant="secondary" onClick={handleBack} style={{ flexShrink: 2 }}>
          Back
        </Button>

        <Button
          size="medium"
          onClick={handleNextButton}
          disabled={disable}
          style={{ flexShrink: 1 }}
        >
          Next
        </Button>
      </Box>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    formData: state.formData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        setDataAction,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form6);
